import Capital from '../views/Capital'

const DashboardPage = () => {
  return <Capital />
}

export default DashboardPage
